const API = require('common/infra/api/group');
const GroupRole = require('common/domain/entity/group-role');

class Repository {
    constructor(group) {
        this._group = group;
        this._roles = new Backbone.Collection([], {model: GroupRole});
        this._fetched = false;
    }

    getRoles() {
        return this._roles
    }

    fetchRoles() {
        return new Promise((resolve, reject) => {
            if(this._fetched) {
                resolve(this._roles);
            } else {
                API.getGroupRoles(this._group.id)
                    .then(roleJSONs => {
                        this._roles.add(roleJSONs, {merge: true});
                        this._fetched = true;
                        resolve(this._roles);
                    }, reject);
            }
        });
    }

    getRole(roleID) {
        return this.fetchRoles().then(() => this._roles.get(roleID))
    }
}

const repositories = {};

const find = function(group) {
    let r = repositories[group.id];
    if (!r) {
        r = new Repository(group);
        repositories[group.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./common/domain/repository/group-role.js